import React,{Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route } from 'react-router-dom';
import './App.css';

import TopNav from './components/topNav/TopNav';
import Nav from './components/nav/Nav';

import Details from './components/details/Details';
// import AllData from './components/products/AllData';
import Products from './components/products/Products';
import Favourite from './components/favorite/Favourite';
import Cart from './components/cart/Cart';



class App extends Component {



  render() {
    return (
      <BrowserRouter>
      <TopNav />
      <Nav />
      
      <Route path="/" component={Products} exact />
      <Route path="/details/:id" component={Details} />
      <Route path="/favourite" component={Favourite} />
      <Route path="/cart" component={Cart} />
    </BrowserRouter>
    )
  }
}

export default App
